<template>
  <div class="home-ds ds-scope homeLayout" :data-testid="TEST_ID.HOME.ROOT">
    <div class="homeContent">
      <div class="homeGrid">
        <div class="homeGridMain">
          <div v-if="shouldRenderAvisosImportantes" class="homePanel homeImportantNotices" :data-testid="TEST_ID.HOME.SECTION_AVISOS_IMPORTANTES">
            <DsAvisosImportantes :avisos="avisosImportantes" />
          </div>

          <div class="homePanel homePanelMain homeNewsSection" :data-testid="TEST_ID.HOME.SECTION_NOTICIAS">
            <div class="sectionTitle ds-h3">{{ $t('NOTICIAS_noticias') }}</div>
            <DsNoticia :data="noticias" />
          </div>
        </div>

        <div class="homeGridAside">
          <div class="homePanel homeArchivosPanel" :data-testid="TEST_ID.HOME.SECTION_ARCHIVOS">
            <div class="sectionTitle">
              <el-row>
                <el-col :span="8" class="ds-h3">{{ $t('ARCHIVOS_archivos') }}</el-col>
              </el-row>
            </div>
            <div class="homeFilesContainer">
              <VueFinderView
                compact
                tree-only
                theme="mythril"
                :show-tree-view="true"
                :show-files-in-tree="true"
                finder-id="colvennet-archivos-home"
                :test-id="TEST_ID.HOME.VUEFINDER_ARCHIVOS"
                :download-test-id="TEST_ID.HOME.VUEFINDER_DOWNLOAD"
                @path-change="handleVueFinderPathChange"
                @error="handleVueFinderError"
              />
            </div>
          </div>

          <el-row class="homeForosRow">
            <div class="homePanel" :data-testid="TEST_ID.HOME.SECTION_FORO">
              <div class="sectionTitle">
                <el-row>
                  <el-col :span="8" class="ds-h3">{{ $t('FORO_foros') }}</el-col>

                  <el-col :span="16" class="homeForoPager">
                    <el-pagination
                      background
                      size="small"
                      layout="prev, pager, next"
                      :total="paginadorForos.totalObjects"
                      :page-size="paginadorForos.pageSize"
                      :pager-count="5"
                      hide-on-single-page
                      @current-change="onForoPageChange"
                    />
                  </el-col>
                </el-row>
              </div>

              <div v-if="cargandoForos" class="loader">
                <el-icon class="is-loading primary"><Loading /></el-icon>
                <div class="primary text-loader ds-body-small">{{ $t('GENERAL_cargando') }} {{ $t('FORO_foros') }}</div>
              </div>
              <div v-else>
                <Foros :data="foros" />
              </div>
            </div>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DsNoticia from '../ds/DsNoticia'
import DsAvisosImportantes from '../ds/DsAvisosImportantes'
import VueFinderView from '../Archivos/VueFinderView'
import Foros from './DsForo'
import { showError } from '../Mensaje'
import TEST_ID from '@/testIds.json'

const cantidadEntradas = 4

export default {
  name: 'DsHome',
  components: { DsNoticia, Foros, DsAvisosImportantes, VueFinderView },

  data() {
    return {
      TEST_ID,
      noticias: [],
      avisosAbortController: null,
      foros: undefined,
      paginadorForos: {
        page: 0,
        pageSize: cantidadEntradas,
        totalObjects: 0
      },
      cargandoForos: false
    }
  },

  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      avisosImportantes: state => state.avisosImportantes.avisos,
      estadoAvisosImportantes: state => state.avisosImportantes.estado
    }),
    shouldRenderAvisosImportantes() {
      return this.estadoAvisosImportantes === 'ready' && this.avisosImportantes.length > 0
    }
  },

  methods: {
    getNoticias() {
      this.$store.dispatch('noticias/getNoticiasPublicadas', { page: 0, pageSize: 1000 })
        .then(data => (this.noticias = data.Result))
    },
    async loadAvisosImportantes() {
      if (this.avisosAbortController) {
        this.avisosAbortController.abort()
      }

      const requestController = new AbortController()

      this.avisosAbortController = requestController

      try {
        await this.$store.dispatch('avisosImportantes/getAvisos', {
          usuarioId: this.idUsuario,
          controller: requestController
        })
      } catch (error) {
        console.error('[DsHome] Error inesperado al resolver avisos importantes.', error)
      } finally {
        if (this.avisosAbortController === requestController) {
          this.avisosAbortController = null
        }
      }
    },
    getForos() {
      const payload = {
        page: this.paginadorForos.page,
        pageSize: this.paginadorForos.pageSize,
        cantidadEntradas: cantidadEntradas
      }

      this.cargandoForos = true
      this.$store.dispatch('foro/getUltimasEntradasForo', payload)
        .then(data => {
          this.foros = data.Result
          this.paginadorForos.totalObjects = data.TotalObjects
        })
        .finally(() => (this.cargandoForos = false))
    },
    onForoPageChange(page) {
      this.paginadorForos.page = page - 1
      this.getForos()
    },
    handleVueFinderPathChange() {
      // Path is already persisted in archivos/vueFinderPath by VueFinderView.
      // Kept for future Home ↔ cargarArchivo synchronization (Fase 7).
    },
    handleVueFinderError() {
      showError(this.$t('ARCHIVOS_error_listado'))
    }
  },

  mounted() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    this.loadAvisosImportantes()
    this.getNoticias()
    this.getForos()
  },

  beforeUnmount() {
    if (this.avisosAbortController) {
      this.avisosAbortController.abort()
      this.avisosAbortController = null
    }
  }
}

</script>

<style src="./home.css"></style>
